import apiRequestCommon from './index'

export default {
  path: '/v1/myss/change/sscd',
  // マイSS登録・更新API
  async put (appVersionHeader, tsid, otoken, procdiv, sscd, mysskbn) {
    await window.callNativeHTTPX()
    const headers = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'X-CLS-App-Version': appVersionHeader
    }
    const body = {
      tsid,
      otoken,
      procdiv,
      sscd,
      mysskbn
    }
    return apiRequestCommon.put(this.path, body, {
      headers
    })
  }
}
